import { AxiosError } from "axios";
import { toast } from "./Helpers";

type Error = {
  message: string;
  errors: Record<string, any>;
};

const handle = async (err: unknown): Promise<any> => {
  const error = err as AxiosError<Error>;
  if (error.response) {
    const status = error.response.status;
    const message = error.response.data.message;
    switch (status) {
      case 422:
        return error.response.data.errors;
      case 401:
        await toast({ message });
        break;
      case 404:
        await toast({ message: `Record not found (${status})` });
        break;
      default:
        await toast({ message: message || `Server error (${status})` });
    }
  }
};

export default {
  handle,
};
